import React, { useState, useEffect } from 'react';

const KEY = 'jsdb_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [detail, setDetail] = useState(false);
  const [prefs, setPrefs] = useState({ analytics: true, marketing: false });

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (!stored) setTimeout(() => setVisible(true), 2000);
  }, []);

  const accept = (all = true) => {
    localStorage.setItem(KEY, JSON.stringify({ analytics: all || prefs.analytics, marketing: all || prefs.marketing, ts: Date.now() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookie consent">
      <div className="cookie-inner">
        <div className="cookie-icon">🍪</div>
        <div className="cookie-body">
          <p className="cookie-title">We use cookies</p>
          <p className="cookie-desc">
            We use cookies to improve your experience, analyse traffic, and personalise content.
            {' '}<button className="cookie-link" onClick={() => setDetail(v => !v)}>{detail ? 'Hide details ▲' : 'Manage preferences ▼'}</button>
          </p>
          {detail && (
            <div className="cookie-prefs">
              <label className="cookie-pref">
                <input type="checkbox" checked disabled /> <span>Essential cookies <em>(always on)</em></span>
              </label>
              <label className="cookie-pref">
                <input type="checkbox" checked={prefs.analytics} onChange={e => setPrefs(p => ({ ...p, analytics: e.target.checked }))} />
                <span>Analytics cookies</span>
              </label>
              <label className="cookie-pref">
                <input type="checkbox" checked={prefs.marketing} onChange={e => setPrefs(p => ({ ...p, marketing: e.target.checked }))} />
                <span>Marketing cookies</span>
              </label>
            </div>
          )}
        </div>
        <div className="cookie-actions">
          <button className="cookie-decline" onClick={() => accept(false)}>Decline</button>
          {detail && <button className="cookie-custom" onClick={() => accept(false)}>Save preferences</button>}
          <button className="cookie-accept" onClick={() => accept(true)}>Accept all</button>
        </div>
        <button className="cookie-close" onClick={() => accept(false)} aria-label="Close">✕</button>
      </div>
    </div>
  );
}
